import React, { useEffect, useState } from 'react'

import {Col, Form, InputGroup, Row} from 'react-bootstrap'

import i18next from 'i18next'
import Select from 'react-select'
import {useTranslation} from 'react-i18next'
import CurrencyInput from 'react-currency-input-field'
import { get } from 'http'
import { getCommodities } from 'src/api/modules/getdatalist'

type Prop = {
  separateValue3: (p1: any, p2: any, p3: any, p4: any) => void
  fieldClearer: (p: any) => void
  separateValue2: (p1: any, p2: any, p3: any) => void
  separateValue: (p1: any, p2: any, p3: any) => void
  getSectorDesc: (p1: any, p2: any, p3: any) => void
  cityData: (p: any) => void
  cityDestinationData: (p: any) => void
  productTypeChange: (p: any) => void
  setPname: (p: any) => void
  setQuantum: (p: any) => void
  setShipping: (p: any) => void
  setketerangan: (p: any) => void
  setEnduser: (p: any) => void
  setEnduserDesc: (p: any) => void
  setEnduserArray: (p: any) => void
  setIsNoEnduser: (p: any) => void
  setSektor: (p: any) => void
  productNameChange: (p: any) => void
  setNote: (p: any) => void
  setSubprice: (p: any) => void
  setFormulaPrice: (p: any) => void
  setPspec: (p: any) => void
  plantChange: (p: any) => void
  setCommodity: (p: any) => void
  setIDSector: any
  commodity: any
  setSektorDesc: any
  setIncoterm1: any
  setIncoterm1Desc: any
  setProdusen: any
  setDistribution: any
  setProdusenDesc: any
  setPay1: any
  setPay1Desc: any
  setSegment: any
  setSegmentDesc: any
  setIncoterm2: any
  setIncoterm2Desc: any
  setCity: any
  setCityDesc: any
  setPay2: any
  setPay2Desc: any
  setDestinationCity: any
  setDestinationCityDesc: any
  setTransType: any
  setTransType2: any
  setTransportasi: any
  setTransOptionType: any
  salesArea: any
  idSektor: any
  produsen: any
  pnumber: any
  pname: any
  language: any
  test: any
  arrayEnduser: any
  roleUser: any
  province: any
  ptype: any
  formulaPrice: any
  city: any
  subprice: any
  transOptionType: any
  isNoEnduser: boolean
  loadingPrice: boolean
  fullProvince: any[]
  fullProvinceDest: any[]
  fullProductType: any[]
  fullIncoterm: any[]
  fullPayment: any[]
  fullSegment: any[]
  fullEndUser: any[]
  fullSector: any[]
  fullIncoterm2: any[]
  fullCity: any[]
  fullProductName: any[]
  fullPlant: any[]
  fullDestinationCity: any[]
  fullTransport: any[]
  fullTransportType: any[]
}

const FormCreateRetail: React.FC<Prop> = ({
  separateValue2,
  separateValue,
  cityData,
  cityDestinationData,
  productTypeChange,
  setPname,
  setQuantum,
  setketerangan,
  setEnduser,
  setEnduserDesc,
  productNameChange,
  setNote,
  setPspec,
  plantChange,
  setCommodity,
  setIncoterm1,
  setIncoterm1Desc,
  setPay1,
  setPay1Desc,
  setCity,
  setCityDesc,
  setPay2,
  setPay2Desc,
  setTransType,
  setTransType2,
  setTransportasi,
  setTransOptionType,
  setDestinationCity,
  setDestinationCityDesc,
  idSektor,
  produsen,
  pnumber,
  pname,
  language,
  test,
  roleUser,
  province,
  ptype,
  city,
  subprice,
  transOptionType,
  loadingPrice,
  fullProvince,
  fullProvinceDest,
  fullProductType,
  fullIncoterm,
  fullPayment,
  fullCity,
  fullProductName,
  fullPlant,
  fullDestinationCity,
  fullTransport,
  fullTransportType
}) => {
  const {t} = useTranslation()
  const [commodities, setCommodities] = useState<any>([])

  useEffect(() => {
    setListCommodities()
  }, [])

  const setListCommodities = async () => {
    const response = await getCommodities();
    
    setCommodities(response.data?.data.map((item: any) => {
      return {
        value: item.name,
        label: item.name,
      }
    }))
  }

  return (
    <>
      <Row>
        <Col md={6}>
          <Row className='mb-4'>
            <Col sm={4}>
              <p className='fs-6 mt-3'>
                {t('sub-order-incoterm1')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
              <Select
                key={produsen + idSektor}
                placeholder={t('pilih')}
                id='incoterm1'
                onChange={(e: any) => separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)}
                options={fullIncoterm}
              />
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {idSektor == 2 ? t('destination-city') : t('pickup-city')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
              <Select
                key={province}
                placeholder={t('pilih')}
                id='kota'
                onChange={(e: any) => {
                  separateValue2(setCity, e?.value, setCityDesc)
                  // fieldClearer(4)
                }}
                options={fullCity}
              />
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={4}>
              <p className='fs-6 mt-3'>
                {t('sub-order-jenis')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
              <Form.Select
                size='sm'
                aria-label='Default select example'
                id='jenis'
                onChange={(e: any) => productTypeChange(e.target.value)}
              >
                <option hidden value='~#~'>
                  {t('Pilih-productType')}
                </option>
                {fullProductType.map((item: any) => {
                  return (
                    <>
                      {item.id != 12 && (
                        <option value={item.material_group_desc + '~#~' + item.material_group}>
                          {t(item.material_group_desc)}
                        </option>
                      )}
                    </>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>

          {/* <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {t('destination-province')}
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              <Select
                key={idSektor + produsen}
                placeholder={t('pilih')}
                id='dest-provinsi'
                onChange={(e: any) => cityDestinationData(e?.value)}
                options={fullProvinceDest}
              />
            </Col>
          </Row> */}

          {parseInt(pnumber) == 0 && (
            <Row className='mb-4'>
              <Col sm={4}>
                <p className='fs-6'>
                  Custom Product Name<span className='text-danger'>*</span>
                </p>
              </Col>
              <Col sm={8}>
                <Form.Control
                  placeholder='Custom Product Name'
                  size='sm'
                  aria-label='Default select example'
                  type='text'
                  id='custom'
                  onChange={(e: any) => setPname(e.target.value)}
                />
              </Col>
            </Row>
          )}
          <Row className='mb-4'>
            <Col sm={4}>
              <p className='fs-6 mt-3'>
                {t('Kuantum Pengajuan')}
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              <InputGroup size='sm'>
                <CurrencyInput
                  className='form-control form-control-sm'
                  id='kuantum'
                  // key={pname}
                  placeholder={t('Kuantum Pengajuan')}
                  decimalSeparator={language === 'en' ? '.' : ','}
                  groupSeparator={language === 'en' ? ',' : '.'}
                  onValueChange={(value: any) => {
                    setQuantum(value?.replace(/,/g, '.'))
                  }}
                  decimalsLimit={2}
                />
                <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
              </InputGroup>
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {t('kontrak-pembayaran')}
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              <Form.Select
                size='sm'
                aria-label='Default select example'
                id='payment1'
                onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
              >
                <option hidden value='~#~'>
                  {t('Pilih-payment')}
                </option>
                {fullPayment.map((item: any, index: number) => {
                  return (
                    <option key={item?.id ?? index} value={item.code + '~#~' + item.payment_desc_id}>
                      {item.payment_desc_id}
                    </option>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={4} className='d-flex align-items-center'>
              <p className='fs-6'>{t('so-jenisAngkut')} <span className='text-danger'>*</span></p>
            </Col>
            <Col sm={8}>
              <Form.Select
                aria-label='Default select example'
                size='sm'
                id='ttrans'
                placeholder={t('so-jenisAngkut')}
                onChange={(e: any) => separateValue(setTransType, e.target.value, setTransType2)}
              >
                <option selected value='~#~'>
                  {t('pilih')} {t('so-jenisAngkut')}
                </option>
                {fullTransport.map((item: any) => {
                  return (
                    <>
                      <option value={item.name_id + '~#~' + item.name_en}>
                        {i18next.language == 'en' ? item.name_en : item.name_id}
                      </option>
                    </>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={4} className='d-flex align-items-center'>
              <p className='fs-6'>{t('keterangan')}</p>
            </Col>
            <Col sm={8}>
              <Form.Control
                as='textarea'
                placeholder={t('keterangan')}
                defaultValue={test?.payment_note}
                id='keterangan'
                size='sm'
                style={{height: '40px'}}
                onChange={(e: any) => setketerangan(e.target.value)}
              />
            </Col>
          </Row>
          <Row className='mb-4'>
              <Col sm={4}>
                <p className='fs-6 mt-3'>{t('commodity')}</p>
              </Col>
              <Col sm={8}>
                <Select
                  key={idSektor + produsen}
                  placeholder={t('pilih')}
                  id='commodities'
                  onChange={(e: any) => setCommodity(e.value)}
                  options={commodities}
                  menuPlacement='top'
                />
              </Col>
          </Row>
        </Col>

        <Col md={6}>
        <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {idSektor == 2 ? t('destination-province') : t('pickup-province')}
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              <Select
                key={idSektor + produsen}
                placeholder={t('pilih')}
                id='provinsi'
                onChange={(e: any) => cityData(e?.value)}
                options={fullProvince}
              />
            </Col>
          </Row>
          
          <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {t('pickup-plant')}
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              <Select
                id='gudang'
                key={city}
                placeholder={t('pilih')}
                onChange={(e: any) => plantChange(e?.value)}
                options={fullPlant}
              />
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={4}>
              <p className='fs-6 mt-3'>
                {t('sub-order-produk')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
            {/* {JSON.stringify(fullProductName) + pname + pnumber} */}
            {
              fullProductName.length > 0 ?
              <Select
                id={'produk'+produsen+ptype}
                key={produsen+ptype}
                placeholder={t('pilih')}
                onChange={(e: any) => {
                  productNameChange(e?.value)
                  // fieldClearer(1)
                }}
                isDisabled={loadingPrice}
                options={fullProductName}
              /> : <Select
              id='produk'
              key={ptype +produsen}
              placeholder={t('pilih')}
              isDisabled={loadingPrice}
              options={[]}
            />
            }
            </Col>
          </Row>

          {/* <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {t('destination-city')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
              <Select
                key={province}
                placeholder={t('pilih')}
                id='kota'
                onChange={(e: any) => {
                  separateValue2(setDestinationCity, e?.value, setDestinationCityDesc)
                  // fieldClearer(4)
                }}
                options={fullDestinationCity}
              />
            </Col>
          </Row> */}

          {/* <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>{t('sub-order-spek')} <span className='text-danger'>*</span></p>
            </Col>
            <Col sm={8}>
              <Form.Control
                as='textarea'
                placeholder={t('sub-order-spek')}
                id='spek'
                size='sm'
                style={{height: '40px'}}
                onChange={(e: any) => setPspec(e.target.value)}
              />
            </Col>
          </Row> */}

          {parseInt(pnumber) == 0 && (
            <Row className='mb-4'>
              <Col sm={4}>
                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
              </Col>
              <Col sm={8}>
                <Form.Control
                  as='textarea'
                  placeholder={t('sub-order-catatan')}
                  id='note'
                  size='sm'
                  style={{height: '40px'}}
                  onChange={(e: any) => setNote(e.target.value)}
                />
              </Col>
            </Row>
          )}

          <Row className='mb-4'>
            <Col sm={4} className='d-flex align-items-center'>
              <p className='mt-3 fs-6'>
                {t('Price')}/Ton
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              {loadingPrice ? (
                <div className='p-3 bg-secondary'>
                  <i className='fa fa-spin fa-spinner'></i>
                </div>
              ) : (
                <InputGroup size='sm'>
                  <InputGroup.Text id='basic-addon2'>
                    <span className='px-1'>Rp</span>
                  </InputGroup.Text>
                  <Form.Control
                    size='sm'
                    id='hargap'
                    value={
                      i18next.language === 'en'
                        ? parseInt(subprice).toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : parseInt(subprice).toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })
                    }
                    disabled
                  />
                </InputGroup>
              )}
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md={4}>
            <p className='mt-3 fs-6'>
                {t('so-namaAngkut')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col md={8}>
              <Form.Select
                aria-label='Default select example'
                size='sm'
                id='ttrans'
                placeholder={t('so-jenisAngkut')}
                onChange={(e: any) => {
                  setTransOptionType(e?.target?.value)
                  // if (e?.target?.value != 'lainnya') setTrans(e.target.value)
                }}
              >
                <option value='~#~'>
                  {t('pilih')} {t('so-jenisAngkut')}
                </option>
                {fullTransportType.map((item: any) => {
                  return (
                    <>
                      <option selected={item.value == transOptionType} value={item.value}>
                        {item.label}
                      </option>
                    </>
                  )
                })}
              </Form.Select>

              { transOptionType == 'lainnya' && 
                <Form.Control
                  aria-label='Default select example'
                  size='sm'
                  className='mt-2'
                  id='angkutan'
                  placeholder={t('so-namaAngkut')}
                  onChange={(e: any) => setTransportasi(e.target.value)}
                />
              }
            </Col>
          </Row>

          {parseInt(pnumber) != 0 && (
            <Row className='mb-4'>
              <Col sm={4}>
                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
              </Col>
              <Col sm={8}>
                <Form.Control
                  as='textarea'
                  placeholder={t('sub-order-catatan')}
                  id='note'
                  size='sm'
                  style={{height: '40px'}}
                  onChange={(e: any) => setNote(e.target.value)}
                />
              </Col>
            </Row>
          )}

          {parseInt(pnumber) == 0 && (
            <Row className='mb-4'>
              <Col sm={4}>
                <p className='fs-6 mt-3'>
                  {t('End Customer')}
                  <span className='text-danger'>*</span>{' '}
                </p>
              </Col>
              <Col sm={8}>
                <Form.Control
                  size='sm'
                  as='textarea'
                  id='enduser'
                  style={{height: '40px'}}
                  placeholder={t('End Customer')}
                  onChange={(e: any) => {
                    setEnduser(e.target.value)
                    setEnduserDesc(e.target.value)
                  }}
                />
              </Col>
            </Row>
          )}

        </Col>
      </Row>
    </>
  )
}

export {FormCreateRetail}
